module.exports = "/_next/static/images/bd99424c10a1905960e4fe7805160ccb-phone-with-app-open-and-card@2x-xs.jpg";